import createIcon from '../../createIcon';

/**
 * @component @name LineAxis
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNy45M0wyMC41OSA2LjUyTDE2LjU2IDExLjA1TDkuNSA0LjVMMiAxMi4wMUwzLjUgMTMuNTFMOS42NCA3LjM2TDE1LjIzIDEyLjU0TDEzLjUgMTQuNDlMOS41IDEwLjQ5TDIgMThMMy41IDE5LjVMOS41IDEzLjQ5TDEzLjUgMTcuNDlMMTYuNjkgMTMuOUwyMC41OSAxNy41MUwyMiAxNi4xTDE4LjAyIDEyLjRMMjIgNy45M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LineAxis = createIcon('LineAxis', [
  [
    'path',
    {
      d: 'M22 7.93L20.59 6.52L16.56 11.05L9.5 4.5L2 12.01L3.5 13.51L9.64 7.36L15.23 12.54L13.5 14.49L9.5 10.49L2 18L3.5 19.5L9.5 13.49L13.5 17.49L16.69 13.9L20.59 17.51L22 16.1L18.02 12.4L22 7.93Z',
      key: 'yalm97',
    },
  ],
]);

export default LineAxis;
